import { useTranslation } from "react-i18next";
import PromoManager from "./PromoManager";

export default function PromoCodes() {
  const { i18n } = useTranslation();
  const isEn = i18n.language === "en";
  return (
    <PromoManager
      promoType="generic"
      tag={isEn ? "Marketing" : "Marketing"}
      title={isEn ? "Promo Codes" : "Codici Promo"}
      addLabel={isEn ? "New code" : "Nuovo codice"}
    />
  );
}
